import React, { useState, useEffect } from "react"
import { Card, Table, Divider, Button, Input, Modal } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { apiGet, apiPost, apiPut } from "../utils/apiConnector"
import { employeeApi, companyApi, ismptApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"

const ProfilePage = (props) => {
  const { t } = useTranslation()
  const [profileInformation, setProfileInformation] = useState({})
  const [companyInformation, setCompanyInformation] = useState({})
  const [tokenInput, setTokenInput] = useState("")
  const [omsIdInput, setOmsIdInput] = useState("")
  const [ismpt, setIsmpt] = useState(null)
  const [modal, setModal] = useState(false)
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const getProfileInformation = () => {
    const ownerId = profile.id
    apiGet(employeeApi + "/" + ownerId, {})
      .onOk((res) => {
        setProfileInformation(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {})
      .startSingle()
  }
  const getCompanyInformation = () => {
    const ownerId = profile.id
    apiGet(companyApi + "/" + ownerId, {})
      .onOk((res) => {
        setCompanyInformation(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {})
      .startSingle()
  }
  const getIsmptInformation = () => {
    const ownerId = profile.id
    apiGet(ismptApi + "/" + ownerId, {})
      .onOk((res) => {
        setIsmpt(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {})
      .startSingle()
  }
  const postIsmpt = () => {
    const ownerId = profile.id
    apiPost(ismptApi + "/" + ownerId, { token: tokenInput, omsId: omsIdInput })
      .onOk((res) => {
        console.log(res.data.response)
      })
      .onFail((res) => {
        console.log(res.data)
      })
      .afterAll(() => {
        getIsmptInformation()
      })
      .startSingle()
  }
  const putIsmpt = () => {
    const ownerId = profile.id
    apiPut(ismptApi + "/" + ownerId, { token: tokenInput, omsId: omsIdInput })
      .onOk((res) => {
        console.log(res.data.response)
      })
      .onFail((res) => {
        console.log(res.data)
      })
      .afterAll(() => {
        getIsmptInformation()
      })
      .startSingle()
  }
  const renderModal = () => {
    return (
      <>
        {ismpt ? (
          <Modal
            onClose={() => {
              setTokenInput("")
              setOmsIdInput("")
              setModal(false)
            }}
            open={modal}
            size="mini"
            style={{ height: "max-content", marginTop: "-40vh" }}
          >
            <Card fluid>
              <Card.Header>
                <h3 style={{ margin: 10 }}>{t("Edit") + " " + t("ismpt")}</h3>
              </Card.Header>
              <Card.Content>
                <Table style={{ border: "0px solid red" }}>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell style={{ width: 70 }}>
                        <b>{t("Token")}:</b>
                      </Table.Cell>
                      <Table.Cell>
                        <Input
                          fluid
                          value={tokenInput}
                          placeholder={ismpt.isConnect ? ismpt.token : ""}
                          onChange={(e, d) => {
                            setTokenInput(d.value)
                          }}
                        />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <b>ID {t("SUZ")}:</b>
                      </Table.Cell>
                      <Table.Cell>
                        <Input
                          fluid
                          value={omsIdInput}
                          placeholder={ismpt.isConnect ? ismpt.omsId : ""}
                          onChange={(e, d) => {
                            setOmsIdInput(d.value)
                          }}
                        />
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <div
                  style={{
                    marginTop: 15,
                    marginBottom: 5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Button
                    negative
                    content={t("Cancel")}
                    onClick={() => {
                      setTokenInput("")
                      setOmsIdInput("")
                      setModal(false)
                    }}
                  />
                  <Button
                    positive
                    content={t("Submit")}
                    onClick={() => {
                      setModal(false)
                      if (ismpt.isConnect) {
                        putIsmpt()
                      } else {
                        postIsmpt()
                      }
                    }}
                  />
                </div>
              </Card.Content>
            </Card>
          </Modal>
        ) : (
          <></>
        )}
      </>
    )
  }
  useEffect(() => {
    getProfileInformation()
    getCompanyInformation()
    getIsmptInformation()
    return () => {}
  }, [])
  return (
    <>
      {renderModal()}
      <div>
        <h2>{t("Profile page")}</h2>
        <Card.Group>
          <Card>
            <Card.Header>
              <h3 style={{ margin: 10 }}>{t("Company information")}</h3>
            </Card.Header>
            <Card.Content>
              <Table style={{ border: "0px solid red" }}>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Company BIN")}:</b>
                    </Table.Cell>
                    <Table.Cell>{companyInformation.bin}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Company name")}:</b>
                    </Table.Cell>
                    <Table.Cell>{companyInformation.company}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Address")}:</b>
                    </Table.Cell>
                    <Table.Cell>{companyInformation.address}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Director")}:</b>
                    </Table.Cell>
                    <Table.Cell>{companyInformation.fio}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Contacts")}:</b>
                    </Table.Cell>
                    <Table.Cell>{companyInformation.phoneNumber}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Card.Content>
          </Card>
          <Card>
            <Card.Header>
              <h3 style={{ margin: 10 }}>{t("Profile information")}</h3>
            </Card.Header>
            <Card.Content>
              <Table style={{ border: "0px solid red" }}>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Login")}:</b>
                    </Table.Cell>
                    <Table.Cell>{profileInformation.login}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Name Surname")}:</b>
                    </Table.Cell>
                    <Table.Cell>{profileInformation.name}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Mobile phone")}:</b>
                    </Table.Cell>
                    <Table.Cell>{profileInformation.phone}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Email")}:</b>
                    </Table.Cell>
                    <Table.Cell>{profileInformation.mail}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Card.Content>
          </Card>
          {ismpt ? (
            <Card>
              <Card.Header>
                <h3 style={{ margin: 10 }}>{t("ismpt")}</h3>
              </Card.Header>
              <Card.Content>
                <Table style={{ border: "0px solid red" }} fluid>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>
                        <b>{t("Status")}:</b>
                      </Table.Cell>
                      <Table.Cell>
                        {ismpt.isConnect ? t("connected") : t("not connected")}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row
                      style={{ display: ismpt.isConnect ? "" : "none" }}
                    >
                      <Table.Cell>
                        <b>{t("Token")}:</b>
                      </Table.Cell>
                      <Table.Cell>
                        {ismpt.isConnect ? ismpt.token : ""}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row
                      style={{ display: ismpt.isConnect ? "" : "none" }}
                    >
                      <Table.Cell>
                        <b>ID {t("SUZ")}:</b>
                      </Table.Cell>
                      <Table.Cell>
                        {ismpt.isConnect ? ismpt.omsId : ""}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <div
                  style={{
                    marginTop: 15,
                    marginBottom: 5,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    positive
                    content={ismpt.isConnect ? t("Edit") : t("Connect")}
                    onClick={() => {
                      if (ismpt.isConnect) {
                        setTokenInput(ismpt.token)
                        setOmsIdInput(ismpt.omsId)
                      }
                      setModal(true)
                    }}
                  />
                </div>
              </Card.Content>
            </Card>
          ) : (
            <></>
          )}
        </Card.Group>
      </div>
    </>
  )
}

export default ProfilePage
